import React from 'react';
import { FSRemoveLightBoxStore } from '../../_flux/stores/fs_remove_light_box_store';
import { FSRemoveLightBox } from '../../_flux/components/fs_remove_light_box/fs_remove_light_box';
import { expandAction, hideAction } from '../../_flux/actions/fs_remove_light_box_actions';
import LightboxStore from '../../_flux/stores/lightbox_store';
import FittingStationStore from '../../_flux/stores/fitting_station_store';
import ActiveStationStore from '../../_flux/stores/active_station_store';
import { clickOnLearnMore, clickOnOk, clickOnRemove, close } from '../../_modules/google_analytics/fs_remove_light_box';
import { handleView } from '../handle_view';

const stores = {
    fsRemoveLightBox: FSRemoveLightBoxStore,
    lightBox: LightboxStore,
    fittingStation: FittingStationStore,
    activeStationState: ActiveStationStore,
};

function render(
    {
        fsRemoveLightBox,
        lightBox,
        fittingStation,
        activeStationState,
    },
    options
) {
    const { visible, expanded } = fsRemoveLightBox;
    const FSFLightBoxVisible = lightBox.visible;
    const detailModeStation = fittingStation.detailModeStation;
    const activeStation = activeStationState.activeStation;

    return (
        <FSRemoveLightBox
            visible={visible}
            expanded={expanded}
            FSFLightBoxVisible={FSFLightBoxVisible}
            detailModeStation={detailModeStation}
            activeStation={activeStation}
            error={{ ...fsRemoveLightBox }}
            onExpand={onExpand}
            onAccept={onAccept}
            onClose={onClose}
            onRemove={options.onRemove}
        />
    );
}

const getOptions = options => ({
    ...options,
    onRemove: onRemoveFactory(options.onRemove),
});

export const init = (container, options) =>
    handleView(stores, render, getOptions(options), container);

const onExpand = () => {
    expandAction();
    clickOnLearnMore();
};

const onAccept = () => {
    hideAction();
    clickOnOk();
};

export const onClose = () => {
    hideAction();
    close();
};

const onRemoveFactory = (onRemove) => () => {
    onRemove();
    clickOnRemove();
};
